export const ListTitles = {
  AssetsMaster: 'Asset_Master',
  IndicationMaster: 'Indication_Master',
  TAMaster: 'TA_Master',
  Channels: 'Channels',
  Communities: 'AC-Resources',
  Aems: 'AEM Metrics',
  AemsPersonal: 'AEM Metrics_Persnl',
  AemSummaries: 'AEM Summaries',
  SubClassification: 'SubClassification',
  CollateralTypes: 'CollateralTypes',
  HelpMaterialsConfiguration: 'HelpMaterialsConfiguration',
  CountryMaster: 'AllCountriesMaster',
  CountryAem: 'Countries',
  HtaKeywords: 'HTA Keywords',
  GlossaryTerms : 'Glossary Terms',
  faqKeywords: 'FAQ Keywords',
  BusinessNeed: 'BusinessNeed',
  TypeOfInteractions: 'TypeOfInteractions',

  CommunityResourceDefaults:'AC-Resource-Defaults',
  CommunityCountryDefaults: 'AC-Country-Defaults',
  CommunityHtaCountries: 'AC-HTA-Countries',
  CommunityNegotiationCountries: 'AC-Negotiation-Countries',
  CommunityPolicyCountries: 'AC-Policy-Countries',
  CommunityHTAResourceTypes: 'AC-HTA-Resource-Types',
  CommunityNegotiationResourceTypes: 'AC-Negotiation-Resource-Types',
  CommunityPolicyResourceTypes: 'AC-Policy-Resource-Types',

  CommunityHtaDocuments: 'ACHTADocuments',
  CommunityHtaDocumentsLibraryTitle: 'AC-HTA-Documents',
  CommunityHtaDocumentsSecure: 'ACHTADocumentsSecure',
  CommunityHtaDocumentsSecureTitle: 'AC-HTA-Documents-Secure',
  CommunityNegotiationDocuments: 'ACNegotiationDocuments',
  CommunityNegotiationDocumentsTitle: 'AC-Negotiation-Documents',
  CommunityNegotiationDocumentsSecure: 'ACNegotiationDocumentsSecure',
  CommunityNegotiationDocumentsSecureTitle: 'AC-Negotiation-Documents-Secure',
  CommunityPolicyDocuments: 'ACPolicyDocuments',
  CommunityPolicyDocumentsTitle: 'AC-Policy-Documents',
  CommunityACOtherDocumentsTitle: 'AC-Other-Documents',
  CommunityPolicyDocumentsSecure: 'ACPolicyDocumentsSecure',

  AEMGuidanceDocuments: 'AEM Guidance',
  ACGuidanceDocuments: 'AC-Guidance',
  ESAGuidance: 'ESA Guidance',
  EEPGuidance: 'EEP Guidance',

  HTAEarlyScientificAdvice: 'HTA Early Scientific Advice',
  HTAESAResources: 'HTA Scientific Advice Resources',
  ESAResourceTypeMapping: 'ESAResourceTypeMapping',

  ExternalExpertPanel: 'ExternalExpertPanel',
  ExpertContracts: 'ExpertContracts',
  ExternalExpertRequests: 'ExternalExpertRequests',
  ExternalExpertRequestsInteraction: 'ExternalExpertRequestsInteraction',
  ExpertProfilePictureLibraryTitle: 'Expert Profile Picture',
  EEPTempEmailNotification: 'EEPTempEmailNotification',
  ExternalExpertSessionTopics: 'ExternalExpertSessionTopics',
  ExternalExpertSessionAttachments: 'External Expert Session Attachments',
  ExternalExpertExpertiseCategory: 'ExternalExpertExpertiseCategory',

  TPInsightsGuidance: 'TP1-TP2Guidance',
  TPInsightsList: 'TP1-TP2',
  TPInsightsResources: 'TP1TP2ResourceTypeMapping',
  TPInsightsDocs: 'TP1-TP2Resources',
  TPResourcesDocs: 'TP1TP2Resources',

  HTAEMCGuidance: 'HTA EMC Guidance',
  HTAEMCResources: 'HTA Economic Model Co-creation Resources', // Documents
  HTAEMCResourcesFolder: 'HTA Economic Model Cocreation Resources', // Create folder
  HTAEMCList: 'HTA Economic Model Cocreation',
  HTAEMCTypeMapping: 'HTAEconomicTypeMapping',

  HTATrends: 'HTA Trends',
  HTAtrends_Buttons: 'HTAtrends_Buttons',
  HTALearningsTracker: 'HTA Learnings Tracker',
  HTAEducation: 'HTA Education',
  MAAPGuidance: 'Guidance Materials',
  MAAPResourceList: 'Market Access Analysis Plan',
  MAAPEvidenceTracker: 'MAAT Evidence Tracker Files',
  MAAPResource: 'MAAPResourceTypeMapping',
  MAAPDocuments: 'MarketAccessAnalysisPlan',
  MAAPResults: 'MAAP Results',

  PRTimelineList: 'SubmissionTimeline',
  PRTimelineTypes: 'TimelineTypes',
  PRTimelineTypesDetail: 'TimelineTypesDtl',
  HtaInformationalMaterial: 'HTA Informational Material',
  PRTimelineDocuments: 	'TimelineAttachments',

  PRSRGuidance: 'HSR Guidance',
  PRSRResourcesList: 'HTASubmission Resources',
  PRSRSubResourceTypeMapping: 'HTASubResourceTypeMapping',
  PRSRDocuments: 'HTA Submission Resources',

  AEMDomain_Comments:'AEMDomain_Comments',
  AEMReferenceDocuments:'AEMReferenceDocuments',
  AEMOverallComments:'AEMOverallComments',
  AEMOverallCitationsComments:'AEMOverallCitationsComments',
  AEMMetricsConfig:'AEMMetrics_Config',
  
  FAQSQuestions: 'FAQQuestions',
  FAQUserMapping: 'FAQ-UserMapping',
  FAQAnswersDocuments: 'Reimbursement QnA Documents',
  PATriggerManagementList: 'AccessHubPowerAutomateTriggerManagement',

  MarketAccessDatabases: 'MarketAccessDatabases',
  MarketAccessDatabases_Buttons: 'MarketAccessDatabases_Buttons',
  MarketAccessDatabases_KeyFeatures: 'MarketAccessDatabases_KeyFeatures',

  HTAEconomicModelITCNMA: 'HTA Economic Model ITC-NMA',
  HTAEconomicModelITCNMADocuments: "HTA Economic Model ITC-NMA Documents",
  saveHTAEconomicModelITCNMADocuments: 'HTA Economic Model ITCNMA Documents',

  AccessTrends : 'AccessTrends',  	
  acHtaFAQSQuestions: 'AC-HTA-FAQQuestions',	
  acHtaFAQUserMapping: 'AC-HTA-FAQ-UserMapping',
  acHtaFAQAnswersDocuments: 'ACHTAReimbursement QnA Documents',

  GlossaryCategories : 'Glossary Categories',

  brandTrackerNames: 'Brands-Tracker',
  brandTrackerData: 'Brands-Tracker-Data',
  brandTrackerTAs: 'Brands-Tracker-TA',
  brandTrackerIndications: 'Brands-Tracker-Indications',
  brandTrackerRegions: 'Brands-Tracker-Region',
  brandTrackerCountries: 'Brands-Tracker-Country',
  brandTrackerUserPermissions: 'Brands-Tracker-User-Permissions',

  contractRightsList: 'ContractRightBestPracticeExamples',
  contractRightsAreas: 'AllAreasMaster',  
  contractRightsExternalProductsList: 'ContractRightsExternalProducts',
  contractRightGuidance: 'ContractRightGuidance',
  contractRightCustomVariable: 'ContractRightPricingCustomVariables',
  ContractRightPricingCustomVariablesAttachments: 'ContractRightPricingCustomVariablesAttachments',
  contractRightFrameworkGuidance: 'ContractRightFrameworkGuidance',

  aercCatalogs: 'AERCCatalogs',
  aercComparisonDataPersonalViews: 'AERCComparisonDataPersonalViews',
  aercComparisonTabs: 'AERCComparisonTabs',
  aercCountryComparisonData: 'AERCCountryComparisonData',
  aercDomainsMaster: 'AERCDomainsMaster',
  aercCatalogCategories: 'AercCatalogCategories',
  aercCatalogArticles: 'AERCCatalogArticles',
  aercCatalogArticlesPublished: 'AERCCatalogArticlesPublished',
  aercCatalogUserCountryMapping: 'AERCCatalogUserCountryMapping',
  aercCatalogCountryCatagoryTemplates: 'AERCCatalogCountryCatagoryTemplates',
 
  notificationSubscription: 'Notification Subscription',

  enhancementReuestForm: 'AccessHubEnhancementRequestForm'
};

export const ListItemTypes = {
  Community: 'SP.Data.ACResourcesListItem',
  Aem: 'SP.Data.AEM_x0020_MetricsListItem',
  HTAEarlyScientificAdvice: 'SP.Data.HTA_x0020_Early_x0020_Scientific_x0020_AdviceListItem',
  TPInsights: 'SP.Data.TP1TP2ListItem',
  MAAP: 'SP.Data.Market_x0020_Access_x0020_Analysis_x0020_PlanListItem',
  PRSR: 'SP.Data.HTASubmission_x0020_ResourcesListItem',
  ItcHe: 'SP.Data.HTA_x0020_Economic_x0020_Model_x0020_CocreationListItem',
  PRTimelineList: 'SP.Data.SubmissionTimelineListItem'
};

export const ListTypes = {
  List: "List",
  Library: "Library"
}

export const ExtensionMappings = {
  docx: "doc",
  doc: "doc",
  docm: "doc",
  dot: "doc",
  dotx: "doc",
  xls: "xls",
  xlsx: "xls",
  xlsb: "xls",
  xlsm: "xls",
  xml: "xls",
  csv: "xls",
  xps: "xls",
  ppt: "ppt",
  pptx: "ppt",
  pptm: "ppt",
  pot: "ppt",
  potm: "ppt",
  pps: "ppt",
  ppsx: "ppt",
  ppsm: "ppt",
  mp4: "vid",
  avi: "vid",
  wmv: "vid",
  mov: "vid",
  mkv: "vid",
  flv: "vid",
  rm: "vid",
  zip: "zip",
  rar: "zip",
  '7z': "zip",
  pdf: "pdf",
  txt: "txt",
  msg: "email",
  html: "html",
  jpg: "img",
  tiff: "img",
  jpeg: "img",
  png: "img",
  bmp: "img",
  gif: "img",
  ico: "img",
  url: "url",
  css: "code",
  ts: "code",
  json: "code",
  js: "code",
  dat: "sys",
  sys: "sys",
  generic: "generic"
};

export const Areas = ["All", "WEC", "EEMEA", "LATAM", "JAPAC"];
